import { HeaderVariant } from 'ucl/components/header/types';

// make it not too huge on os font scaling or else our layouts become broken
export const HEADER_MAX_FONT_SIZE_MULTIPLIER = 1.7; // headers are particularly sensitive to this, smaller value
export const ACTION_BUTTON_MAX_FONT_SIZE_MULTIPLIER = 2.2; // action buttons are particularly sensitive to this, smaller value
export const BODY_MAX_FONT_SIZE_MULTIPLIER = 2.5; // bodies are less sensitive to this, larger value

/** in silly nativebase format (combines styles and props) but now shared to new Typography component
 * TODO REMOVE and consolidate into Typography after nativebase Text removal in a better structure
 */
const coreTextVariants = {
  hero: {
    accessibilityRole: 'header',
    fontFamily: 'heading',
    fontSize: [32, 32, 32, 56],
    lineHeight: [36, 36, 36, 56],
    mb: 3, // TODO change to marginBottom after nativebase Text removal
    maxFontSizeMultiplier: HEADER_MAX_FONT_SIZE_MULTIPLIER,
  },
  headerOne: {
    accessibilityRole: 'header',
    fontFamily: 'heading',
    fontSize: [24, 24, 24, 30],
    lineHeight: [24, 24, 24, 32],
    mb: 3, // TODO change to marginBottom after nativebase Text removal
    maxFontSizeMultiplier: HEADER_MAX_FONT_SIZE_MULTIPLIER,
  },
  headerTwo: {
    accessibilityRole: 'header',
    accessibilityLevel: 2,
    fontFamily: 'heading',
    fontSize: [18, 18, 18, 24],
    lineHeight: [20, 20, 20, 28],
    mb: 3, // TODO change to marginBottom after nativebase Text removal
    maxFontSizeMultiplier: HEADER_MAX_FONT_SIZE_MULTIPLIER,
  },
  headerThree: {
    accessibilityRole: 'header',
    accessibilityLevel: 3,
    fontFamily: 'heading',
    fontSize: [16, 16, 16, 18],
    lineHeight: 20,
    mb: 3, // TODO change to marginBottom after nativebase Text removal
    maxFontSizeMultiplier: HEADER_MAX_FONT_SIZE_MULTIPLIER,
  },
  headerFour: {
    accessibilityRole: 'header',
    accessibilityLevel: 4,
    fontFamily: 'heading',
    fontSize: 13,
    lineHeight: 16,
    mb: 3, // TODO change to marginBottom after nativebase Text removal
    maxFontSizeMultiplier: HEADER_MAX_FONT_SIZE_MULTIPLIER,
  },
  copyOne: {
    fontFamily: 'body',
    fontSize: [15, 15, 15, 16],
    lineHeight: [20, 20, 20, 24],
    maxFontSizeMultiplier: BODY_MAX_FONT_SIZE_MULTIPLIER,
  },
  copyTwo: {
    fontFamily: 'body',
    fontSize: [12, 12, 12, 13],
    lineHeight: [16, 16, 16, 20],
    maxFontSizeMultiplier: BODY_MAX_FONT_SIZE_MULTIPLIER,
  },
  bodyOne: {
    fontFamily: 'body',
    fontSize: [13, 13, 13, 14],
    lineHeight: [16, 16, 16, 16],
    maxFontSizeMultiplier: BODY_MAX_FONT_SIZE_MULTIPLIER,
  },
  formUtility: {
    fontFamily: 'body',
    fontSize: 11,
    lineHeight: 12,
    maxFontSizeMultiplier: BODY_MAX_FONT_SIZE_MULTIPLIER,
  },
  link: {
    fontFamily: 'body',
    fontSize: 14,
    maxFontSizeMultiplier: BODY_MAX_FONT_SIZE_MULTIPLIER,
    textDecorationLine: 'underline',
    cursor: 'pointer',
    accessibilityRole: 'link',
  },
};

const noRoleOrLevel = {
  accessibilityRole: undefined,
  accessibilityLevel: undefined,
};

// variants that don't have a header a11y role
const lookVariants = {
  headerOneLook: {
    ...coreTextVariants.headerOne,
    ...noRoleOrLevel,
  },
  headerTwoLook: {
    ...coreTextVariants.headerTwo,
    ...noRoleOrLevel,
  },
  headerThreeLook: {
    ...coreTextVariants.headerThree,
    ...noRoleOrLevel,
  },
  headerFourLook: {
    ...coreTextVariants.headerFour,
    ...noRoleOrLevel,
  },
};

export const textVariants = {
  ...coreTextVariants,
  ...lookVariants,
};

export type TextVariant = HeaderVariant | 'copyOne' | 'copyTwo' | 'bodyOne' | 'formUtility';
